import { useMutation } from '@apollo/client/react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
} from '@optools/components/ui/alert-dialog';
import { Button } from '@optools/components/ui/button';
import { DELETE_ESNI_RULE } from '@optools/services/operator-gateway/esni/mutations';
import { ESNI_RULES } from '@optools/services/operator-gateway/esni/queries';
import { toast } from 'sonner';

export interface DeleteEsniRuleDialogProps {
  name: string;
  onDeleteEnsiRule?: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  ruleId: string;
}

export function DeleteEsniRuleDialog({
  name,
  onDeleteEnsiRule,
  onOpenChange,
  open,
  ruleId,
}: DeleteEsniRuleDialogProps) {
  const [deleteEsniRule, { loading }] = useMutation(DELETE_ESNI_RULE, {
    awaitRefetchQueries: true,
    onCompleted: ({ deleteEsniRule }) => {
      if (!deleteEsniRule.success) {
        toast.error('Delete Esni Rule Failed', {
          description: deleteEsniRule.reason ?? '',
          duration: Infinity,
        });
        return;
      }

      toast.success('Deleted Esni Rule');
      onDeleteEnsiRule?.();
      onOpenChange(false);
    },
    refetchQueries: [{ query: ESNI_RULES }],
  });

  const handleOnDelete = () => {
    deleteEsniRule({ variables: { ruleId } });
  };

  const handleOnOpenChange = (open: boolean) => {
    if (!loading) {
      onOpenChange(open);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={handleOnOpenChange}>
      <AlertDialogContent>
        <AlertDialogTitle>Delete ESNI Rule</AlertDialogTitle>
        <AlertDialogDescription>
          Are you sure you want to delete ESNI rule: <span className="font-black">{name}</span>?
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>
          <Button
            disabled={loading}
            loading={loading}
            variant="destructive"
            onClick={handleOnDelete}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
